export default {
  handler: 'relativeUrl',
  data: ({
    sportId, meetingId, eventId, sportCouponGroupId,
  }) => {
    const eventUrl = `/sports/${sportId}/meetings/${meetingId}/events/${eventId}`;

    return sportCouponGroupId ? `${eventUrl}/market_group/${sportCouponGroupId}` : eventUrl;
  },
};
